import { computed, inject, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { TranslateService } from '@ngx-translate/core'
import { Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppLanguages } from '../../shared/constants/enums'
import { TRANSLATE_CONFIG } from '../configs/translate-config'

@Injectable({ providedIn: 'root' })
export class AppLanguageService {
    private translate = inject(TranslateService)

    languageChanged$ = new Subject<void>()
    appLanguage = toSignal(this.languageChanged$.pipe(map(() => this.getAppLanguage())), {
        initialValue: this.getAppLanguage()
    })
    isPolishLanguage = computed<boolean>(() => this.appLanguage() === AppLanguages.PL)

    getAppLanguage(): string {
        const appLanguage = localStorage.getItem('appLanguage')
        if (appLanguage && Object.values<string>(AppLanguages).includes(appLanguage)) {
            return appLanguage
        }
        return TRANSLATE_CONFIG.defaultLanguage!
    }

    setAppLanguage(lang: AppLanguages): void {
        this.translate.use(lang)
        localStorage.setItem('appLanguage', lang)
        this.languageChanged$.next()
    }

    removeAppLanguage(): void {
        localStorage.removeItem('appLanguage')
    }
}
